const unitMeasurements = {

  install (Vue, options) {
    Vue.prototype.UnitMeasurements = {
      QUANTITIVE: ['Pulse', 'Miligram', 'Gram', 'Unit']
    }
  }
}

export default unitMeasurements



// WEBPACK FOOTER //
// ./src/constants/unitMeasurements.js